import classes from './index.hooks';

export const mainNavigationBarVariantClasses = {
  'v2.1': classes.mainNavGlobal,
  universal: classes.mainNavUniversal,
};
